import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import { usePopoverFull } from "@website/ui/popover-full/popover-full.hook";
import styles from "@website/ui/popover-full/popover-full.module.scss";
import { PopoverFullPropertiesType } from "@website/ui/popover-full/popover-full.types";
import { TransitionV2 } from "@website/ui/transition";
import { FC } from "react";
export const PopoverFull: FC<PopoverFullPropertiesType> = properties => {
  const $ = _c(16);
  const {
    animate,
    children,
    title,
    position,
    StartAction,
    EndAction,
    gapHorizontal,
    gapVertical,
    className
  } = properties;
  const {
    rootProps,
    transitionProps,
    popoverOpen,
    animateOpen
  } = usePopoverFull(properties);
  const {
    isMobile
  } = useViewPort();
  if (popoverOpen) {
    let t0;
    if ($[0] !== EndAction || $[1] !== StartAction || $[2] !== animate || $[3] !== children || $[4] !== className || $[5] !== gapHorizontal || $[6] !== gapVertical || $[7] !== isMobile || $[8] !== position || $[9] !== rootProps || $[10] !== title) {
      t0 = state => <div {...rootProps} className={`${styles["popover-full"]} ${className} ${styles[position || "start"]} ${animate === "normal" ? "" : `${styles.animate} ${state === "entering" || state === "entered" ? styles["animate-enter"] : styles["animate-exit"]}`} `} style={{
        marginBlockStart: isMobile ? "0px" : gapVertical || "0px",
        ...(position === "start" ? {
          marginInlineStart: isMobile ? "0px" : gapHorizontal || "0px"
        } : {
          marginInlineEnd: isMobile ? "0px" : gapHorizontal || "0px"
        })
      }}>{StartAction || title || EndAction ? <div className={styles.header}>{StartAction}<div className={styles.title}>{title}</div>{EndAction}</div> : null}<div className={`${styles.main}`}>{children}</div></div>;
      $[0] = EndAction;
      $[1] = StartAction;
      $[2] = animate;
      $[3] = children;
      $[4] = className;
      $[5] = gapHorizontal;
      $[6] = gapVertical;
      $[7] = isMobile;
      $[8] = position;
      $[9] = rootProps;
      $[10] = title;
      $[11] = t0;
    } else {
      t0 = $[11];
    }
    let t1;
    if ($[12] !== animateOpen || $[13] !== t0 || $[14] !== transitionProps) {
      t1 = <TransitionV2 {...transitionProps} in={animateOpen}>{t0}</TransitionV2>;
      $[12] = animateOpen;
      $[13] = t0;
      $[14] = transitionProps;
      $[15] = t1;
    } else {
      t1 = $[15];
    }
    return t1;
  }
  return null;
};